import { Component, OnInit, Optional, Inject } from '@angular/core';
import { DataService } from '../../services/utils/data.service';
import { RefundStatusService } from '../../services/rest-api/refund-status.service';
import { TranslatorService } from 'src/app/modules/translator/providers/translator.service';
import { InterpolationService } from 'src/app/services/utils/interpolation.service';

@Component({
  selector: 'app-refund-status-error-dialog',
  templateUrl: './refund-status-error-dialog.component.html',
  styleUrls: ['./refund-status-error-dialog.component.css']
})
export class RefundStatusErrorDialogComponent implements OnInit {

  ticketNumber;
  public pageData: any;

  constructor(private refundStatusService: RefundStatusService,
              private dataService: DataService,
              private translatorService: TranslatorService,
              private interpolatorService: InterpolationService) { }

  getHostname(): string {
    return this.refundStatusService.getHostname();
  }

  ngOnInit() {
    this.getPageData();
    this.dataService.ticketNumber.subscribe( ticketNumber => this.ticketNumber = ticketNumber );
  }

  private getPageData() {
    const dataSet = new Map();
    this.pageData = this.interpolatorService
                        .interpolate(this.translatorService
                                    .getTranslations('refund-status'),
                                    dataSet);
  }

}
